module.exports = __webpack_public_path__ + "static/media/educators_devices.b7639695.png";